import { render, staticRenderFns } from "./MdmParallax.vue?vue&type=template&id=6b8a6c6d&name=mdm-parallax&"
import script from "./MdmParallax.vue?vue&type=script&lang=js&"
export * from "./MdmParallax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports